import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

/***    ANGULAR MATERIAL IMPORT    ***/
// animations
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
// components
import {
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MatDatepickerModule, MatDialogModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
} from '@angular/material';

// Import components from this module
import {DatepickerComponent} from './DatepickerComponent/datepicker.component';
import {DatetimeTermpickerComponent} from './DatetimeTermpickerComponent/datetime-termpicker.component';
import {NgbTimepickerModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ContractStateComponent} from './ContractStateComponent/contract-state.component';
import {LogsComponent} from './LogsComponent/logs.component';
import {MomentModule} from 'angular2-moment';
import {LogService} from '../services/log.service';

@NgModule({
    declarations: [     // Components declared in this module
        DatepickerComponent,
        DatetimeTermpickerComponent,
        ContractStateComponent,
        LogsComponent
    ],
    imports: [
        BrowserModule,

        // Angular Material animations
        BrowserAnimationsModule,

        FormsModule,

        // Angular Material components
        MatDialogModule,
        MatIconModule,
        MatButtonModule,
        MatMenuModule,

        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,

        ReactiveFormsModule,

        NgbTimepickerModule,
        MomentModule,
    ],
    exports: [      // Allow access from other modules to these components
        DatepickerComponent,
        DatetimeTermpickerComponent,
        ContractStateComponent,
        LogsComponent
    ],
    providers: [
        LogService
    ]
})
export class SharedModule {
}



// WEBPACK FOOTER //
// /app/src/SharedModule/shared.module.ts